import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}type-product`;

export const getTypeProducts = () => {
    const token = localStorage.getItem('token');

    return axios.get(API_URL + '/active', {
        headers: {
            'Authorization': `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json', // Menentukan tipe konten yang dikirim (untuk POST/PUT)
            'Accept': 'application/json',       // Menentukan tipe data yang diharapkan dari response
        },
    });
}

export const getTypeProductById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}